import { GameCoinWinOverlayProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameCoinWinOverlayProperties";
export class CoinWinOverlayLandscapeProperties extends GameCoinWinOverlayProperties {
    setDefaultValues() {
        super.setDefaultValues();
    }
}
